import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { sendApiRequest } from "../utils/api";
import LogoLoader from "./LogoLoader";

// fallback
const fallbackTests = [
  {
    id: "basic",
    title: "Beginner Friendly",
    description:
      "Start your stenography journey with easy 40 WPM dictation.",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80",
    fee: 0,
  },
  {
    id: "advanced",
    title: "Speed Challenge",
    description:
      "Practice advanced 80 WPM dictation for faster improvement.",
    image:
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=800&q=80",
    fee: 0,
  },
];

const DemoTests = () => {
  const [demoTests, setDemoTests] = useState([]);
  const [loading, setLoading] = useState(true);

  const transformApiData = (data) =>
    data.map((item) => ({
      id: item._id,
      title: item.name,
      description: item.description,
      image: item.thumbnail,
      fee: item.fee,
    }));

  useEffect(() => {
    const fetchDemoTests = async () => {
      try {
        const res = await sendApiRequest(
          "api/exams/category/68e38d520eb62176aceaa91e",
          {},
          "GET"
        );

        if (res?.success && res?.data?.length) {
          setDemoTests(transformApiData(res.data));
        } else {
          setDemoTests(fallbackTests);
        }
      } catch (err) {
        console.error(err);
        setDemoTests(fallbackTests);
      } finally {
        setLoading(false);
      }
    };

    fetchDemoTests();
  }, []);

  if (loading) {
    return (
      <LogoLoader />
    );
  }

  return (
    <div className="bg-[#1d3a80] py-8 px-4">
      {/* TITLE */}
      <h2 className="text-white text-center text-3xl font-bold mb-6">
        Demo Dictations
      </h2>

      {/* WHITE WRAPPER */}
      <div className="bg-[#f5f7fb] rounded-3xl p-6 max-w-7xl mx-auto">

        {/* ✅ GRID FIX HERE */}
        <div
          className="
            grid
            grid-cols-2          /* 📱 Mobile: 2 cards */
            sm:grid-cols-2
            lg:grid-cols-3       /* 💻 Desktop */
            xl:grid-cols-4
            gap-5
          "
        >
          {demoTests.map((test) => (
            <div
              key={test.id}
              className="bg-white rounded-xl shadow-sm hover:shadow-md transition overflow-hidden"
            >
              {/* IMAGE */}
              <img
                src={test.image}
                alt={test.title}
                className="w-full h-[120px] sm:h-[130px] object-cover"
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/400x200?text=Demo+Test";
                }}
              />

              {/* CONTENT */}
              <div className="p-4 text-center">
                <h3 className="text-[14px] sm:text-[15px] font-semibold text-gray-900 line-clamp-2">
                  {test.title}
                </h3>

                <p className="text-[11px] sm:text-[12px] text-gray-500 mt-1 mb-3 line-clamp-2">
                  {test.description}
                </p>

                <Link
                  to={`/exams/${test.id}`}
                  className="inline-block bg-[#1f4fa3] hover:bg-[#163a7a]
                             text-white text-xs px-4 py-1.5 rounded-md transition"
                >
                  {test.fee === 0 ? "Start Free" : "Start Practice"}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DemoTests;
